var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindowsClosedSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29,8h-7v2h7c0.5517578,0,1,0.4482422,1,1v10c0,0.5517578-0.4482422,1-1,1H2.6181641 C2.2773438,22,2,21.7226562,2,21.3818359c0-0.0957031,0.0224609-0.1914062,0.0654297-0.2763672l3.8291016-7.6582031 C7.3916016,10.4521484,8.1542969,10,10,10h6V8h-6c-3.0761719,0-4.3525391,1.4677734-5.8945312,4.5527344l-3.8291016,7.6582031 C0.0957031,20.5722656,0,20.9775391,0,21.3818359C0,22.8251953,1.1748047,24,2.6181641,24H29c1.6542969,0,3-1.3457031,3-3V11 C32,9.3457031,30.6542969,8,29,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,4H18v2v6h2V6V4h1.5c0.1943359,0,0.3701172-0.1123047,0.453125-0.2880859 c0.0820312-0.1757812,0.0556641-0.3828125-0.0693359-0.5322266l-2.5-3c-0.1894531-0.2285156-0.578125-0.2285156-0.7675781,0l-2.5,3 c-0.125,0.1494141-0.1513672,0.3564453-0.0693359,0.5322266C16.1298828,3.8876953,16.3056641,4,16.5,4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsClosedSmall);
export default __webpack_public_path__ + "static/media/windows-closed--small.d97690bb99aedd35079e6479cf5aafb0.svg";
export { ForwardRef as ReactComponent };